var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6433 1.77371L5.83542 0.0388397C5.76368 0.0129611 5.68975 0 5.61456 0C5.53902 0 5.46405 0.013092 5.39195 0.0392325L0.601357 1.7741C0.34244 1.86802 0.160767 2.11402 0.160767 2.38947V6.49998C0.160767 7.41769 0.456559 8.33553 1.02104 9.22792C1.45374 9.91189 2.05597 10.5826 2.80165 11.2217C4.04845 12.2901 5.28556 12.9063 5.33753 12.9321C5.429 12.9773 5.52964 13 5.62909 13C5.72706 13 5.82569 12.978 5.91611 12.934C5.96809 12.9087 7.20463 12.302 8.45261 11.2379C9.19903 10.6014 9.79223 9.93066 10.2252 9.24429C10.7895 8.34997 11.0708 7.42668 11.0708 6.49998V2.38947C11.0708 2.11358 10.9028 1.86727 10.6433 1.77371ZM1.20813 6.49692V2.8789C1.20813 2.74117 1.29253 2.61815 1.42201 2.57119L5.49416 1.08974C5.53047 1.0766 5.57214 1.06691 5.61578 1.06691V6.50002H10.0545C10.0547 6.50002 10.055 6.50591 10.055 6.50967C10.0542 7.69358 9.45786 8.86693 8.28294 10.0094C7.3654 10.9016 6.32297 11.5384 5.78676 11.8387C5.73706 11.8666 5.65947 11.8798 5.61583 11.8798C5.61583 11.7779 5.61583 6.55645 5.61583 6.49832L1.20813 6.49692Z",
    fill: "#0056CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerShield);
export default __webpack_public_path__ + "static/media/banner-shield.9c2360be.svg";
export { ForwardRef as ReactComponent };